import { TAnalyticsType } from '@monorepo/types';

export const ANALYTICS_TYPE_TITLE_MAP: Record<TAnalyticsType, string> = {
  PLANI8_IN_HOUSE: 'KPIs and Analytics',
};

export const ANALYTIC_TYPE_STORAGE_KEY_MAP: Record<TAnalyticsType, string> = {
  PLANI8_IN_HOUSE: 'plani8_in_house_analytics',
};
